//
//The module wraps up the basic CRUD operations to interact with the server
//The Url parameter should includes all the parameters required to retrieve data from the server
//and they can be added to relevant functions in the service layer
//
import Axios from 'axios'
const TIME_OUT = 30000;
export default {
    name: 'getRequest',

    //
    //Get data from server by GET method without authorization and parameters
    //
    async getData(url) {
        try {
            let response = await Axios.get(url, { timeout : TIME_OUT});
            return response.data;
        }
        catch (err) {
            // console.log(err.code);
            // let error = {
            //     code : null,
            //     message: ''
            // };
            // if (err.code != null) {
            //     error.code = errorCodes.ERRCODE_TIMEOUT;
            //     error.message = 'Please check your network connection!';
            //     error.status = "error";
            // }
            // else {
            //     switch (err.response.status) {
            //         case 400 :
            //             error.code= errorCodes.ERRCODE_400;
            //             error.message = 'Bad request!';
            //             error.status = "error";
            //         case 401 :
            //             error.code= errorCodes.ERRCODE_401;
            //             error.message = 'Unauthorized access!';
            //             error.status = "error";
            //         case 403 :
            //             error.code= errorCodes.ERRCODE_403;
            //             error.message = 'Forbidden!';
            //             error.status = "error";
            //         case 404 :
            //             error.code= errorCodes.ERRCODE_404;
            //             error.message = 'The resource is not found!';
            //             error.status = 404;
            //         case 408 :
            //             error.code= errorCodes.ERRCODE_408;
            //             error.message = 'Tiemout! Please try again later!';
            //             error.status = "error";
            //         case 500 :
            //             error.code= errorCodes.ERRCODE_500;
            //             error.message = 'Internal errors!';
            //             error.status = 500;
            //         default :
            //             error.code= errorCodes.ERRCODE_UNKNOWN;
            //             error.message = 'Internal errors!';
            //             error.status = "error";
            //     }
                
            // }
            
            throw err;
        }
        
    }
}